function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "52",
  height: "52"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_3586",
  "data-name": "Group 3586",
  transform: "translate(-326 -231)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  cx: "26",
  cy: "26",
  r: "26",
  transform: "translate(326 231)",
  fill: "#b71c47"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3593",
  "data-name": "Group 3593",
  transform: "translate(337 242)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_401",
  "data-name": "Path 401",
  d: "M0 0h30v30H0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_402",
  "data-name": "Path 402",
  d: "M20.333 9.8v2.6h-4v5.85a3.256 3.256 0 01-2.214 3.061 3.388 3.388 0 01-3.7-1.006 3.185 3.185 0 01-.27-3.737 3.368 3.368 0 013.519-1.5V9.8H19V4.6H5.667v20.8h18.666V9.8zM3 3.29A1.311 1.311 0 014.332 2h16L27 8.5v18.191A1.316 1.316 0 0125.676 28H4.324A1.317 1.317 0 013 26.71z",
  fill: "#fff"
})))));